import React from "react";
import { numberToLocal, numberToPrice } from "../../helpers/uiFunctions";
import { Statistic, ReportHeading } from "../../helpers/uiComponents";

import { InputRow } from "../../helpers/inputRow";
import { loadSimplifiCampaignStats } from "../data/supermetricsService";
import { errorMessage } from "../../helpers/uiHelpers";

class Geofencing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quickStats: {},
      geofencingLabels: [],
      geofencingValues: [],
      sortVal: 0, //no sorting
      rendered: false,
      message: null,
    };
    this.loadRetailer = this.loadRetailer.bind(this);
  }
  componentDidMount() {
    loadSimplifiCampaignStats(
      this.props.endpoints,
      this.props.currentClient.clientCode,
      localStorage.getItem("accessToken"),
      this.props.dates,
      false
    ).then((response) => {
      if (response.success && response.result.campaign_stats.length > 0) {
        const campaignStats = response.result.campaign_stats[0];
        this.setState({ quickStats: campaignStats });
      } else {
        this.setState({
          message: errorMessage,
          loading: false,
        });
      }
    });

    loadSimplifiCampaignStats(
      this.props.endpoints,
      this.props.currentClient.clientCode,
      localStorage.getItem("accessToken"),
      this.props.dates,
      true
    ).then((response) => {
      if (response.success && response.result.campaign_stats.length > 0) {
        const results = response.result.campaign_stats;
        const geofencingLabels = [
          "Campaign ID",
          "Impressions",
          "Clicks",
          "Click Through Rate",
          "Total Walk-Ins",
        ];

        this.setState({
          geofencingLabels: geofencingLabels,
        });
        const geofencingValues = [];

        for (const key in results) {
          const ad = results[key];
          const row = [
            ad.name,
            ad.impressions,
            ad.clicks,
            ad.ctr,
            ad.weighted_actions,
          ];

          geofencingValues.push(row);
        }

        this.setState({
          geofencingValues: geofencingValues,
        });
      } else {
        this.setState({
          message: errorMessage,
          loading: false,
        });
      }
    });
  }

  loadRetailer(e) {
    try {
      var affiliateCode = e.target.value;
      var currentData = this.props.data[1][1];
      currentData = currentData.filter((ad) => {
        return ad.affiliateCode === affiliateCode;
      });
      this.setState({
        campaigns: currentData,
      });
    } catch(err) {
      console.log('Error on loadRetailer-', err);
    }
    
  }

  clearRetailer() {
    try {
      this.setState({
        campaigns: this.props.data[1][1],
      });
      document.getElementById("adword-retailer-list").selectedIndex = 0;
    } catch(err) {
      console.log('Error on clearRetailer-', err);
    }
    
  }
  sortBy(i) {
    let list = [];
    list = this.state.geofencingValues;

    let sort = this.state.sortVal;
    if (sort === 0 || sort === 2) {
      list = list.sort((a, b) => (a[i] > b[i] ? 1 : -1));
      sort = 1;
    } else {
      list = list.sort((a, b) => (a[i] < b[i] ? 1 : -1));
      sort = 2;
    }

    this.setState({
      geofencingValues: list,
      sortVal: sort, // up or down
    });
  }

  render() {
    const { quickStats, message, geofencingLabels, geofencingValues } =
      this.state;
    
    const hideHistorical = this.props.hideHistorical;
    const isRetailer = this.props.isRetailer;
    const retailerList = this.props.retailerList;
    const roles = this.props.roles;
    // const affiliateCode = this.props.affiliateCode;

    //console.log(ads);

    return (
      this.props.currentClient && (
        <div id="metrics-adwords" className="report metrics-adwords">
          <ReportHeading
            title="Geofencing Statistics"
            name={this.props.currentClient.name}
            dates={this.props.dates}
            hideHistorical={hideHistorical}
          />
          {message && (
            <React.Fragment>
              <h3>We were unable to fetch your Geofencing Statistics.</h3>
              <p>
                There may have been an error connecting to Geofencing, or
                Geofencing is not configured for your Portal.
              </p>
              <p>Please contact your Account Manager for assistance.</p>
            </React.Fragment>
          )}
          {isRetailer === false &&
            retailerList &&
            (roles.includes("portalAdm") ||
              roles.includes("portalVlctyMngr")) && (
              <div className="retailer-selector">
                Retailer:
                <span className="clear-client">
                  <i
                    className="far fa-window-close"
                    onClick={() => this.clearRetailer()}
                  ></i>
                </span>
                <InputRow
                  type="select"
                  id="adword-retailer-list"
                  property="retailerList"
                  options={retailerList}
                  onChange={this.loadRetailer}
                />
              </div>
            )}
          {!message && (
            <React.Fragment>
              <section className="stats row">
                <Statistic
                  label="Total Impression"
                  value={
                    quickStats && quickStats.impressions
                      ? numberToLocal(quickStats["impressions"])
                      : "calculating.."
                  }
                  hideHistorical={true}
                />
                <Statistic
                  label="Total Clicks"
                  value={
                    quickStats && quickStats.clicks
                      ? numberToLocal(quickStats["clicks"])
                      : "calculating.."
                  }
                  hideHistorical={true}
                />
                <Statistic
                  label="Click-Through-Rate"
                  value={
                    quickStats && quickStats.ctr
                      ? numberToLocal(quickStats["ctr"])
                      : "calculating.."
                  }
                  hideHistorical={true}
                />
                <Statistic
                  label="Total Walk-In"
                  value={
                    quickStats && quickStats.weighted_actions
                      ? numberToLocal(quickStats["weighted_actions"])
                      : "calculating.."
                  }
                  hideHistorical={true}
                />
              </section>
              <section className="calls-list">
                <div className="table_wrapper_scroll">
                  <div className="table_wrapper_inner">
                    <div className="table-heading">
                      {geofencingLabels &&
                        geofencingLabels.map((label, index) => (
                          <div
                            key={index}
                            className="sortable"
                            onClick={() => this.sortBy(index)}
                          >
                            {label}
                            {" "}
                            <span>
                              <i className="fas fa-sort"></i>
                            </span>
                          </div>
                        ))}
                    </div>
                    <ul className="table-body no-hover">
                      {geofencingValues &&
                        geofencingValues.map((ad, index) => (
                          <li key={index}>
                            {ad.map((dataPoint, i) => (
                              <div key={i}>
                                {[0].indexOf(i) !== -1 && dataPoint}
                                {[1].indexOf(i) !== -1 &&
                                  numberToLocal(dataPoint)}
                                {[2].indexOf(i) !== -1 &&
                                  numberToLocal(dataPoint)}
                                {[3].indexOf(i) !== -1 &&
                                  numberToLocal(dataPoint)}
                                {[4].indexOf(i) !== -1 &&
                                  numberToLocal(dataPoint)}
                              </div>
                            ))}
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </section>
            </React.Fragment>
          )}
        </div>
      )
    );
  }
}

export default Geofencing;
